import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import VendorContext from "../../../../contexts/VendorContext";
import zoeyLogo from "../../../../assets/images/zoey/zoey-logo.png";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IUpdateSupplierIntegrationsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import { OwFnInput } from "../../../shared/OwFnInput/OwFnInput";
import OwButton from "../../../shared/OwButton/OwButton";
import ICatalog from "../../../../models/ICatalog";
import IOnGetCatalogsDTO from "../../../../models/DTO/IOnGetCatalogsDTO";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import IOnGetPriceGroupsDTO from "../../../../models/DTO/IOnGetPriceGroupsDTO";
import IPrice_Group from "../../../../models/IPrice_Group";
import IGetPriceGroupsDTO from "../../../../models/DTO/IGetPriceGroupsDTO";
import { Socket } from "socket.io-client";

type Props = {
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

export const ZoeyConnect: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);

    const [zoeyConsumerKey, setZoeyConsumerKey] = useState<string>(supplierModel.Supplier_Integration.zoey_consumer_key || "");
    const [zoeyConsumerSecret, setZoeyConsumerSecret] = useState<string>(supplierModel.Supplier_Integration.zoey_consumer_secret || "");
    const [zoeyAccessToken, setZoeyAccesstoken] = useState<string>(supplierModel.Supplier_Integration.zoey_access_token || "");
    const [zoeyTokenSecret, setZoeyTokenSecret] = useState<string>(supplierModel.Supplier_Integration.zoey_token_secret || "");
    const [zoeyContainer, setZoeyContainer] = useState<string>(supplierModel.Supplier_Integration.zoey_container || "");
    const [zoeyCatalogId, setZoeyCatalogId] = useState<number | null | undefined>(supplierModel.Supplier_Integration.zoey_catalog_id);
    const [zoeyPriceGroupId, setZoeyPriceGroupId] = useState<number | null | undefined>(
        supplierModel.Supplier_Integration.zoey_price_group_id
    );
    const [zoeyCatalogPriceGroup, setZoeyCatalogPriceGroup] = useState<{
        catalogId: number | null | undefined;
        priceGroupId: number | null | undefined;
    }>({
        catalogId: supplierModel.Supplier_Integration.zoey_catalog_id,
        priceGroupId: supplierModel.Supplier_Integration.zoey_price_group_id,
    });
    const [catalogs, setCatalogs] = useState<ICatalog[]>([]);
    const [priceGroups, setPriceGroups] = useState<IPrice_Group[]>([]);

    useEffect(() => {
        props.socket.on(EndpointsEnum.CatalogsOnGetCatalogs, onGetCatalogs);

        return () => {
            props.socket.removeListener(EndpointsEnum.CatalogsOnGetCatalogs, onGetCatalogs);
            props.socket.removeListener(EndpointsEnum.CatalogsOnGetPriceGroups, onGetPriceGroups);
        };
    }, []);

    useEffect(() => {
        if (zoeyCatalogId && catalogs.length) {
            getPriceGroups();
        }
    }, [zoeyCatalogId, catalogs]);

    const onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        setCatalogs(data.catalogs);
    };

    const getPriceGroups = () => {
        if (catalogs.length) {
            const catalog = catalogs.find((_catalog) => Number(_catalog.id) === Number(zoeyCatalogId));

            if (catalog) {
                props.socket.on(EndpointsEnum.CatalogsOnGetPriceGroups, onGetPriceGroups);

                const payload: IGetPriceGroupsDTO = {
                    userGuid: userModel.guid,
                    userToken: userModel.token,
                    supplierGuid: supplierModel.guid,
                    catalogGuid: catalog.guid,
                };
                props.socket.emit(EndpointsEnum.CatalogsGetPriceGroups, payload);
            }
        }
    };

    const onGetPriceGroups = (data: IOnGetPriceGroupsDTO) => {
        if (data.priceGroups.length) {
            const firstPriceGroup = data.priceGroups[0];
            if (Number(firstPriceGroup.catalog_id) === Number(zoeyCatalogPriceGroup.catalogId)) {
                setPriceGroups(data.priceGroups);
            }
        }
    };

    const toggleZoey = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                has_zoey: !supplierModel.Supplier_Integration.has_zoey,
            },
        };

        props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        switch (name) {
            case "zoey_consumer_key":
                setZoeyConsumerKey(value);
                break;

            case "zoey_consumer_secret":
                setZoeyConsumerSecret(value);
                break;

            case "zoey_access_token":
                setZoeyAccesstoken(value);
                break;

            case "zoey_token_secret":
                setZoeyTokenSecret(value);
                break;

            case "zoey_container":
                setZoeyContainer(value);
                break;

            case "zoey_catalog_id":
                console.log("zoey_catalog_id", value);
                setZoeyCatalogPriceGroup({
                    ...zoeyCatalogPriceGroup,
                    catalogId: Number(value),
                });
                setZoeyCatalogId(Number(value));
                break;

            case "zoey_price_group_id":
                setZoeyCatalogPriceGroup({
                    ...zoeyCatalogPriceGroup,
                    priceGroupId: Number(value),
                });
                setZoeyPriceGroupId(Number(value));
                break;
        }
    };

    const save = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                zoey_consumer_key: zoeyConsumerKey,
                zoey_token_secret: zoeyTokenSecret,
                zoey_access_token: zoeyAccessToken,
                zoey_consumer_secret: zoeyConsumerSecret,
                zoey_container: zoeyContainer,
                zoey_catalog_id: zoeyCatalogId,
                zoey_price_group_id: zoeyPriceGroupId,
            },
        };

        props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    return (
        <div className={"ZoeyConnect"}>
            <OwAccordion
                leftImage={zoeyLogo}
                leftImageHeight={30}
                hideChevron={!supplierModel.Supplier_Integration.has_zoey}
                rightElem={
                    <div className={"ms-auto"}>
                        <OwToggle fn={toggleZoey} name={"zoey"} label={""} active={!!supplierModel.Supplier_Integration.has_zoey} />
                    </div>
                }>
                <div>
                    <div>
                        <div>
                            <OwLabel title={"consumer_key"} />
                        </div>
                        <div>
                            <OwFnInput fn={handleChange} name={"zoey_consumer_key"} value={zoeyConsumerKey} />
                        </div>
                    </div>

                    <div>
                        <div>
                            <OwLabel title={"consumer_secret"} />
                        </div>
                        <div>
                            <OwFnInput fn={handleChange} name={"zoey_consumer_secret"} value={zoeyConsumerSecret} />
                        </div>
                    </div>

                    <div>
                        <div>
                            <OwLabel title={"access_token"} />
                        </div>
                        <div>
                            <OwFnInput fn={handleChange} name={"zoey_access_token"} value={zoeyAccessToken} />
                        </div>
                    </div>

                    <div>
                        <div>
                            <OwLabel title={"token_secret"} />
                        </div>
                        <div>
                            <OwFnInput fn={handleChange} name={"zoey_token_secret"} value={zoeyTokenSecret} />
                        </div>
                    </div>

                    <div>
                        <div>
                            <OwLabel title={"container"} />
                        </div>
                        <div>
                            <OwFnInput fn={handleChange} name={"zoey_container"} value={zoeyContainer} />
                        </div>
                    </div>

                    <div>
                        <div>
                            <OwLabel title={"default_catalog"} />
                        </div>
                        <div>
                            <OwSelectOption
                                name={"zoey_catalog_id"}
                                options={catalogs}
                                fn={handleChange}
                                valueProp={"id"}
                                titleProp={"name"}
                            />
                        </div>
                    </div>

                    <div>
                        <div>
                            <OwLabel title={"default_price_group"} />
                        </div>
                        <div>
                            <OwSelectOption
                                name={"zoey_price_group_id"}
                                options={priceGroups}
                                fn={handleChange}
                                valueProp={"id"}
                                titleProp={"value"}
                            />
                        </div>
                    </div>

                    <div className={"mt-2"}>
                        <OwButton title={"save"} fn={save} />
                    </div>
                </div>
            </OwAccordion>
        </div>
    );
};
